const styles = (theme) => ({
  scChatWindowClosed: {
    opacity: "0",
    visibility: "hidden",
    bottom: "90px",
  },
  scMessageList: {
    width: "300px",
    overflowY: "auto",
    backgroundSize: "100%",
    wordBreak: "break-word"
  },
  scHeaderCloseButton: {
    boxSizing: "border-box",
    cursor: "pointer",
    borderRadius: "5px",
  },
  scHeaderCloseIcon: {
    padding: "8px ",
    fontSize: "21px",
  },
  scMessage: {
    width: "230px",
    margin: "auto",
    paddingBottom: "20px",
    display: "grid",
  },
  scMessageContent: {
    width: "230px",
    display: "flex",
    cursor: "default",
  },
  scMessageContentSent: {
    justifyContent: "flex-end",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: theme.textFontSize,
    lineHeight: "16px",
  },
  scMessageText: {
    padding: "10px 10px",
    borderRadius: "6px",
    fontWeight: "300",
    fontSize: theme.headerTextFontSize,
    lineHeight: "1.4",
    whiteSpace: "pre-wrap",
    WebkitFontSmoothing: "subpixel-antialiased",
    wordWrap: "break-word",
    width: "204px",
  },
  scMessageContentSentScMessagText: {
    color: theme.tooltipText,
    marginLeft: "36px",
    wordWrap: "break-word",
    backgroundColor: theme.ComponentHeader,
    boxShadow: "0px 3px 4px rgba(0, 0, 0, 0.12)",
    borderRadius: "8px 8px 0px 8px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: theme.textFontSize,
  },
  scMessageContentReceivedScMessageText: {
    color: theme.tooltipText,
    backgroundColor: theme.gridBGColor,
    marginRight: "36px",
    boxShadow: "0px 3px 4px rgba(0, 0, 0, 0.12)",
    borderRadius: "8px 8px 0px 8px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: theme.textFontSize,
  },
  scMessageContentSentReply: {
    background: theme.sendMessageBGColor,
    padding: "8px",
    color: theme.messageTextColor,
  },
  timeStyle: {
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "10px",
    marginLeft: "62%",
  },
  scMessageContentReceivedReply: {
    background: theme.replyMessageBGColor,
    padding: "8px",
    color: theme.messageTextColor,
  },
  scUserInput: {
    margin: "0px",
    position: "relative",
    bottom: "0",
    display: "grid",
    background: theme.ComponentHeader,
    boxShadow: "0px 3px 16px rgba(0, 0, 0, 0.12)",
    transition: "background-color .2s ease,box-shadow .2s ease",
  },
  replyTextMsg: {
    padding: "8px",
    fontSize: theme.textFontSize,
    width: "80%",
  },
  replyDiv: {
    background: theme.messageBackground,
    justifyContent: "space-between",
    border: "solid 5px",
    borderColor: theme.gridBGColor,
    display: "flex",
    color: theme.tooltipText,
    overflowY: "auto",
    wordWrap: "break-word"
  },
  scUserInputText: {
    resize: "none",
    border: "none",
    outline: "none",
    borderBottomLeftRadius: "10px",
    boxSizing: "border-box",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: theme.textFontSize,
    lineHeight: "24px",
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    color: theme.iconColor,
    WebkitFontSmoothing: "antialiased",
    width: "100%",
    overflow: "scroll",
    bottom: "0",
    overflowX: "hidden",
    overflowY: "auto",
    ":empty": {
      content: "Write a reply...",
      display: "block",
      color: theme.iconColor,
    },
    ":before": {
      content: "Write a reply...",
      display: "block",
      color: theme.iconColor,
    },
  },
  scUserInputButtons: {
    height: "100%",
    cursor: "pointer",
    borderRadius: 0,
    padding:8,
    "&:hover": {
      backgroundColor: "white",
    },
    alignItems: "end"
  },
  scUserInputActive: {
    boxShadow: "0px -5px 20px 0px rgba(150, 165, 190, 0.2)",
    color: theme.iconColor,
  },
  unReadMsg: {
    fontSize: "10px",
    marginTop: "20px",
    display: "flex",
    alignItems: "center",
    padding: "5px 12px",
    width: "95px",
    color: theme.ComponentHeader,
    marginLeft: "25%",
    background: theme.HeaderSelectedText,
    borderRadius: "200px",
  },
  textNumberCount: {
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "10px",
    lineHeight: "16px",
    paddingLeft: "8px",
    letterSpacing: "0.4px",
    color: theme.HeaderDefaultTextColor,
    backgroundColor: theme.chatBGColor,
  },
  muiInputBaseInput: {
    // width: "75%",
    display: "flex",
    overflowY: "hidden",
  },
  iconStyle: {
    fontSize: "10px",
  },
  messageContainer: {
    padding: "10px 0px 0px 8px",
  },
  waitingResponseStyle: {
    padding: "10px 0px 0px 8px",
    color: "orange",
  },
  sendResponse: {
    padding: "10px 0px 0px 8px",
    cursor: "pointer",
    color: "orange",
  },
  clearIcon: {
    fontSize: theme.headerTextFontSize,
    padding: "10px",
    cursor: "pointer",
  },
  selectedMessages: {
    flexDirection: "column",
    flex: 1,
    background: theme.chatBGColor,
    padding: "20px 0px",
    height: "175px",
  },
  openCannedMessages: {
    background: theme.ComponentHeader,
    padding: "0px",
    height: "325px",
    position: "absolute",
  },
  loadingMessage: {
    background: theme.chatBGColor,
    display: "flex",
    height: 255,
    justifyContent: "center",
    alignItems: "center",
    fontSize: 12,
    opacity: 0.5,
  },
  viewCannedMessageContainer: {
    height: "304px",
    overflow: "auto",
    marginTop: 8,
  },
  editCannedMessageContainer: {
    height: "304px",
    padding: 12,
    overflow: "auto"
  },
  urgentIcon: {
    color: theme.warningColor,
  },
  urgentMessage: {
    backgroundColor: theme.warningBGColor,
  },
  iconSize: {
    fontSize: 20,
  },
  urgentText: {
    color: theme.warningColor,
    fontSize: 10,
    textTransform: "uppercase",
    padding: "8 0 4 8",
  },
  textArea: {
    overflowY: "auto",
    maxHeight: "55px",
    lineHeight: "13px",
    paddingTop: 8,
  }
});

export default styles;
